import { useEffect, useState } from 'react'

const ONE_SECOND_IN_MS = 1000
const ONE_MINUTE_IN_MS = ONE_SECOND_IN_MS * 60
const ONE_HOUR_IN_MS = ONE_MINUTE_IN_MS * 60
const ONE_DAY_IN_MS = ONE_HOUR_IN_MS * 24
const ONE_WEEK_IN_MS = ONE_DAY_IN_MS * 7

type UseCountdownReturn = {
  totalTimeLeftInMs: number
  weeks: number
  days: number
  hours: number
  minutes: number
  seconds: number
}

export function useCountdown(endTime?: Date | string | null): UseCountdownReturn | null {
  const [countdownComponents, setCountdownComponents] = useState<UseCountdownReturn | null>(null)

  let dateString: string | null = null
  if (endTime instanceof Date) {
    dateString = endTime.toISOString()
  } else if (typeof endTime === 'string') {
    dateString = endTime
  }

  useEffect(() => {
    if (!dateString) {
      return
    }

    const interval = setInterval(() => {
      if (!dateString) {
        return
      }

      const now = new Date()

      let timeLeft = Math.max(0, new Date(dateString).getTime() - now.getTime())
      const totalTimeLeft = timeLeft

      const weeks = Math.floor(timeLeft / ONE_WEEK_IN_MS)
      timeLeft %= ONE_WEEK_IN_MS

      const days = Math.floor(timeLeft / ONE_DAY_IN_MS)
      timeLeft %= ONE_DAY_IN_MS

      const hours = Math.floor(timeLeft / ONE_HOUR_IN_MS)
      timeLeft %= ONE_HOUR_IN_MS

      const minutes = Math.floor(timeLeft / ONE_MINUTE_IN_MS)
      timeLeft %= ONE_MINUTE_IN_MS

      const seconds = Math.floor(timeLeft / ONE_SECOND_IN_MS)

      if (totalTimeLeft <= 0) {
        clearInterval(interval)
      }

      setCountdownComponents({
        totalTimeLeftInMs: totalTimeLeft,
        weeks,
        days,
        hours,
        minutes,
        seconds
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [dateString])

  return countdownComponents
}
